module.exports = __webpack_public_path__ + "static/media/icon-gym.bd5ee9cd.svg";